Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "NotificationSettings4111766068",
  {"root":"NotificationSettings4111766068--root"},
  "",
  3,
  "NotificationSettings4111766068"
);

